(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderTorRuleDialogController', LenderTorRuleDialogController);

    LenderTorRuleDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'LenderTorRule'];

    function LenderTorRuleDialogController ($timeout, $scope, $uibModalInstance, entity, LenderTorRule) {
        var vm = this;

        vm.rule = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('#field_title').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rule.id !== null) {
                LenderTorRule.update(vm.rule, onSaveSuccess, onSaveError);
            } else {
                LenderTorRule.save(vm.rule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:lenderTorRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
